<template>
    <div class="elichain-container">
        <div class="holder" id="holder"></div>
        <div class="logo-container">
            <div class="logo-img">
               <img src="../assets/logo.png"/>
            </div>
        </div>
        <swiper v-bind:options="swiperOption" ref="elichainSwiper">
            <swiper-slide>
                <div class="slogan"><span>科技改变未来  只因我们都在</span></div>
                <div class="map">
<!--                    <div class="map1"></div>-->
                    <div class="map2"></div>
                    <div class="map3"></div>
                </div>
                <div class="first-page-content">
                    <div class="entrance">
                        <div class="mobile-right"></div>
                        <a href="https://www.mulu.life/elichain">
                            <div class="box">
                                <i class="system"></i>慕鹿生态系统
                            </div>
                        </a>
                        <div class="box" @click="downAppPc">
                            <i class="app"></i>慕鹿APP下载
                        </div>
                    </div>
                    <div class="qr-content">
                        <img src="../assets/qrcode_mulu.jpg"/>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-img"><img src="../assets/img/page01.png"></div>
                <div class="swiper-content page-content">
                    <div class="swiper-title">
                        <span>留心生活</span>
                        <span>创新仍在</span>
                    </div>
                    <div class="swiper-summary">
                        以终端用户、经销商、乔金斯等多维度，建立整木行业新型管控及服务一体化平台
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-img"><img src="../assets/img/page02.png"></div>
                <div class="swiper-content page-content">
                    <div class="swiper-title">
                        <span>信息驱动</span>
                        <span>数据改革</span>
                    </div>
                    <div class="swiper-summary">
                        建立庞大的乔金斯互联网生态数据池，快速的数据流转和动态的数据体系、多样的数据类型和巨大的数据价值
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-img"><img src="../assets/img/page03.png"></div>
                <div class="swiper-content page-content">
                    <div class="swiper-title">
                        <span>完美诠释</span>
                        <span>七大系统</span>
                    </div>
                    <div class="swiper-summary">
                        整合ERP生产管理系统、CRM客户管理系统、SCM供应链系统、WMS仓储管理系统、酷家乐3D云设计、商学院、商城系统
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-img"><img src="../assets/img/page04.png"></div>
                <div class="swiper-content page-content">
                    <div class="swiper-title">
                        <span>随时随地</span>
                        <span>移动办公</span>
                    </div>
                    <div class="swiper-summary">
                        各项业务合理串连，移动APP与PC一体化，任何时间、任何地点、处理任何工作
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-img"><img src="../assets/img/page05.png"></div>
                <div class="swiper-content page-content">
                    <div class="swiper-title">
                        <span>知识协作</span>
                        <span>由此开启</span>
                    </div>
                    <div class="swiper-summary">
                        IaaS学习架构体系，自由配置的学习培训任务，项目制学习定时任务、学考一体，游戏化学习
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-img"><img src="../assets/img/page06.png"></div>
                <div class="swiper-content page-content">
                    <div class="swiper-title">
                        <span>把控情绪</span>
                        <span>沟通无阻</span>
                    </div>
                    <div class="swiper-summary">
                        提供IM即时通讯，运用AI技术分析每一次的沟通，及时提醒坏情绪的产生
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="end-content">
                    <div class="wrap">
                        <div class="end-title">
                            <span class="mulu">Elichain</span>
                            <span> 慕鹿生态平台</span>
                            <div class="desc">打造居家生活一体化服务平台</div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
        <div class="nav-container">
            <div class="nav-sign-container">
                0
                <div class="nav-sign-item">
                    <div class="nav-sign">1</div>
                    <div class="nav-sign">2</div>
                    <div class="nav-sign">3</div>
                    <div class="nav-sign">4</div>
                    <div class="nav-sign">5</div>
                    <div class="nav-sign">6</div>
                    <div class="nav-sign">7</div>
                    <div class="nav-sign">8</div>
                </div>
            </div>
            <div class="nav-text-container">
                <div class="nav-top"></div>
                <div class="nav-bottom"></div>
                <div class="nav-text">初识慕鹿</div>
                <div class="nav-text">创新平台</div>
                <div class="nav-text">数据时代</div>
                <div class="nav-text">七大系统</div>
                <div class="nav-text">高效办公</div>
                <div class="nav-text">知识协作</div>
                <div class="nav-text">情绪分析</div>
                <div class="nav-text">初心未变</div>
            </div>
        </div>
        <div :class="isLast?'copyright copyright-show':'copyright'">
            <div class="pc-text">
                慕鹿（elichain）以多维度管理及服务一体化，整合乔金斯生态系统，专注于乔金斯的服务、品质、设计，增强乔金斯品牌效应
            </div>
            <div class="copyright-text">
                <span>© {{years}}</span>
                <span>杭州乔金斯科技集团有限公司</span>
                <span>版权所有</span>
                <div class="beian">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802010845">
                        <img src="../assets/beian.png" />
                        <p>浙公网安备 33010802010845号</p>
                    </a>
                </div>
                <a href="https://beian.miit.gov.cn" target="_blank" class="icp">浙ICP备19009360号-3</a>
            </div>
        </div>
        <div class="download-container" v-show="isBtn"  @click="downAppPc" @mouseover="hoverBtnIn('down')" @mouseout="hoverBtnOut('down')">
            <div class="left-light" id="down-left"></div>
            <div class="right-light" id="down-right"></div>
            现在下载
        </div>
        <div class="down-arrow" v-if="!isLast"></div>
        <div class="download_platform_dialog" v-if="download_dialog">
            <div class="dialog_mask"></div>
            <div class="dialog_container">
                <div class="dialog_closeButton" @click="download_dialog=false">X</div>
                <div class="download_platform_dialog_content">
                    <div class="download_platform_dialog_list">
                        <div class="download_platform_dialog_item">
                            <img src="../assets/qrcode_mulu.jpg">
<!--                            <p class="download_platform_dialog_itemTitle">慕鹿平台</p>-->
<!--                            <p class="download_platform_dialog_itemDesc">打开微信扫码下载</p>-->
                        </div>
                        <div class="download_platform_dialog_remark">
                            请使用微信扫码，关注"慕鹿平台"公众号，打开公众号"慕鹿APP"下载<br><br>仅支持乔金斯内部员工以及所有经销商使用，慕鹿生活客户端敬请期待
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wx_downliad_dialog" v-if="iswxDownload">
            <img src="../assets/wx_down.png">
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { initBg } from '../../static/elichain.js'

export default {
    name: "Index",
    components: {
        swiper,
        swiperSlide
    },
    data () {
        return {
            iswxDownload: false,
            download_dialog: false,
            isLast: false,
            isBtn: false,
            years: '2019',
            pagenum: 8,
            swiperOption:{
                direction: 'vertical',
                mousewheel: true,
                mousewheelControl : true,
                paginationClickable: true,
                parallax: true,
                speed: 600,
                keyboardControl : true,
                mousewheelForceToAxis : true,
                mousewheelReleaseOnEdges : true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                on: {
                    slideChange: ()=>{
                        let eswiper = this.$refs.elichainSwiper.swiper
                        const navKeyDistance = -(eswiper.activeIndex * 100);
                        const navDistance = -(eswiper.activeIndex * 35);
                        const signList = document.querySelectorAll('.nav-sign')
                        for ( let sign of signList ) {
                            sign.style.transform =`translateY(${navKeyDistance}%)`
                        }
                        const textList = document.querySelectorAll('.nav-text')
                        for ( let text of textList ) {
                            text.style.transform =`translateX(${navDistance}px)`
                        }
                        if( eswiper.activeIndex === this.pagenum-1 ) {
                            this.isLast = true
                        } else {
                            this.isLast = false
                        }
                        if ( eswiper.activeIndex === 0 ) {
                            this.isBtn = false
                        } else {
                            this.isBtn = true
                        }
                    }
                }
            }
        }
    },
    mounted() {
        let nowDate = new Date()
        this.years = this.years + '-' + nowDate.getFullYear()
        initBg()
    },
    methods: {
        hoverBtnIn(d){
            const left = document.querySelector('#'+d+'-left')
            const right = document.querySelector('#'+d+'-right')
            left.style.left = `-10px`
            right.style.right = `-10px`
            setTimeout(function() {
                left.style.left = `10px`
                right.style.right = `10px`
            }, 300)
        },
        hoverBtnOut(d){
            const left = document.querySelector('#'+d+'-left')
            const right = document.querySelector('#'+d+'-right')
            left.style.left = `-10px`
            right.style.right = `-10px`
            setTimeout(function() {
                left.style.left = `0`
                right.style.right = `0`
            }, 300)
        },
        downAppPc() {
            let p = navigator.platform;
            let u = navigator.userAgent;
            let is_android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            let is_ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (p == "Win32" || p == "Win64" || p == "MacPPC" || p == "MacIntel" || p == "X11" || p == "Linux i686") {//PC调试环境
                this.download_dialog = true
            }
            else {
                if (is_android) {//Android终端
                    if (navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1) {
                        this.iswxDownload = true
                    }else{
                        window.location.href="https://www.mulu.life/TCF/api/getAppStaffAndroidApk";
                    }

                }
                else if (is_ios) {//IOS终端
                    window.location.href="https://apps.apple.com/cn/app/id1558810558";
                }
            }
        }
    }
}
</script>
